import { wrap } from 'girder/utilities/PluginUtils';
import { AccessType } from 'girder/constants';
import events from 'girder/events';
import HierarchyWidget from 'girder/views/widgets/HierarchyWidget';
import AnalysesMenuWidget from './widgets/AnalysesMenuWidget';
import AnalysesMenuTemplate from '../templates/widgets/analysesMenu.pug';
import { restRequest } from 'girder/rest';

var jszip;
var counter = 0;
var mainFolder = '';

wrap(HierarchyWidget, 'render', function (render) {
    const root = this;

    render.call(this);

    this.events['change .g-select-all'] = updateCheckAll;
    this.events['click .download-annotations'] = downloadAllAnnotations;
    this.events['click .import-annotations'] = browseAnnotationFile;
    this.events['change #h-annotations-import'] = importAnnotations;
    this.delegateEvents();

    var checkedButton = root.$el.find('.g-checked-actions-button');
    var checkedButtonParent = checkedButton ? checkedButton.parent() : '';
    if (checkedButtonParent) {
        checkedButtonParent.append(AnalysesMenuTemplate({
            menuTitle: "Analyses actions"
        }));
    }
    var folderActions = root.$el.find('.g-folder-actions-menu');
    if (folderActions && this.parentModel.resourceName == 'collection') {
        folderActions.find(' > li:last-child').before(
            '<li><a class="download-annotations" role="menu-item"><i class="icon-download"></i>Download annotations</a></li>' +
            '<li class="divider" role="presentation"></li>'
        );
    } else if (folderActions && this.parentModel.resourceName == 'folder') {
        folderActions.find(' > li:last-child').before(
            '<li><a class="download-annotations" role="menu-item"><i class="icon-download"></i>Download annotations</a></li>' +
            '<li><a class="import-annotations" id="h-browse-folder" role="menu-item">' +
            '<i class="icon-upload"></i>Upload annotated images' +
            '<span class="h-annotations-browse-file"><input type="file" id="h-annotations-import" webkitdirectory mozdirectory /></span></a></li>' +
            '<li class="divider" role="presentation"></li>'
        );
    }

    var zipCdn = document.createElement("script");
    zipCdn.type = "text/javascript";
    zipCdn.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.2.2/jszip.min.js';
    $("head").append(zipCdn);

    var fileSaverCdn = document.createElement("script");
    fileSaverCdn.type = "text/javascript";
    fileSaverCdn.src = 'https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/1.3.8/FileSaver.min.js';
    $("head").append(fileSaverCdn);

    /**
     * Format a Date object as a localized string.
     */
    function formatDate(s) {
        return s.toISOString();
    }

    function uploadChunkFiles(file, uploadId, afile, uploadChunkSize, startByte, imageFileLength, annotationLength) {
        var endByte = Math.min(startByte + uploadChunkSize, file.size);
        var sliceFn = file.webkitSlice ? 'webkitSlice' : 'slice';
        var blob = file[sliceFn](startByte, endByte);
        restRequest({
            url: `/file/chunk?offset=${startByte}&uploadId=${uploadId}`,
            method: 'POST',
            data: blob,
            contentType: false,
            processData: false,
        }).then((chunkResponse) => {
            if (endByte === file.size) {
                startByte = 0;
                $('#g-dialog-container').css('display', 'none');
                $('.modal-backdrop').css('display', 'none');
                var annotationFile = afile;
                var fd = new FileReader();
                fd.onload = (e) => {
                    let result;
                    try {
                        result = JSON.parse(e.target.result);
                    } catch (e) {
                        alert(`The uploaded file is not in proper JSON format - ${annotationFile.name}`);
                        return false;
                    }
                    var formatted = JSON.stringify(result, null, 2);
                    restRequest({
                        url: `/item/${chunkResponse.itemId}`,
                        method: 'GET'
                    }).then((response) => {
                        if (response["largeImage"] == undefined) {
                            restRequest({
                                url: `/item/${chunkResponse.itemId}/tiles`,
                                method: 'POST',
                                data: {
                                    fileId: chunkResponse._id,
                                    notify: true
                                }
                            }).then((response) => {
                                if (response == null) {
                                    restRequest({
                                        url: `/annotation/item/${chunkResponse.itemId}`,
                                        contentType: 'application/json',
                                        data: formatted,
                                        method: 'POST'
                                    }).then((result) => {
                                        annotationLength++;
                                        if (imageFileLength == annotationLength) {
                                            events.trigger('g:alert', {
                                                icon: 'ok',
                                                text: 'Successfully imported images and annotations',
                                                type: 'success',
                                                timeout: 2000
                                            });
                                            window.setTimeout(function () {
                                                window.location.reload();
                                            }, 1000);
                                        }
                                    });
                                }
                            });
                        } else if (response["largeImage"] != undefined) {
                            restRequest({
                                url: `/annotation/item/${chunkResponse.itemId}`,
                                contentType: 'application/json',
                                data: formatted,
                                method: 'POST'
                            }).then((result) => {
                                annotationLength++;
                                if (imageFileLength == annotationLength) {
                                    events.trigger('g:alert', {
                                        icon: 'ok',
                                        text: 'Successfully imported images and annotations',
                                        type: 'success',
                                        timeout: 2000
                                    });
                                    window.setTimeout(function () {
                                        window.location.reload();
                                    }, 1000);
                                }
                            });
                        }
                    });
                }
                fd.readAsText(annotationFile);
            } else {
                startByte = endByte;
                uploadChunkFiles(file, uploadId, afile, uploadChunkSize, startByte, imageFileLength, annotationLength);
            }
        });
    }

    function browseAnnotationFile(evt) {
        document.getElementById('h-annotations-import').click();
    }

    function importAnnotations(evt) {
        var uploadChunkSize = 1024 * 1024 * 64;
        var startByte = 0;
        var imageFileLength = 0;
        var annotationLength = 0;
        var folderId = this.parentModel.attributes._id;
        let files = document.getElementById('h-annotations-import').files;
        var validFileExtensions = ["jpg", "jpeg", "bmp", "gif", "png", "svs", "tif", "vms", "vmu", "ndpi", "scn", "mrxs", "tiff", "svslide", "bif", "qptiff"];
        if (files.length <= 0) {
            alert('Please browse a file to upload');
            return false;
        }
        restRequest({
            url: `/folder?parentType=folder&parentId=${folderId}`,
        }).then((folders) => {
            //let privateFolderId = folders.filter(folder => folder.name == "Private")[0]._id;
            events.trigger('g:alert', {
                icon: 'ok',
                text: 'Folder upload is in processing',
                type: 'info',
                timeout: 4000
            });
            Object.keys(files).forEach(temp => {
                if (validFileExtensions.includes(files[temp].name.split('.').pop().toLowerCase())) {
                    var fr = new FileReader();
                    fr.onload = (e) => {
                        restRequest({
                            url: `/file`,
                            data: {
                                parentType: 'folder',
                                parentId: folderId,
                                name: files[temp].name,
                                size: files[temp].size,
                                mimeType: files[temp].type
                            },
                            method: 'POST'
                        }).then((fileResponse) => {
                            imageFileLength++;
                            Object.keys(files).forEach(key => {
                                if (files[key].type.includes('/json')) {
                                    if (files[temp].name.replace(/\.[^/.]+$/, "") == files[key].name.replace(/\.[^/.]+$/, "")) {
                                        uploadChunkFiles(files[temp], fileResponse._id, files[key], uploadChunkSize, startByte, imageFileLength, annotationLength);
                                    }
                                }
                            });
                        });
                    }
                    fr.readAsText(files[temp]);
                } else if (!files[temp].type.includes('/json')) {
                    events.trigger('g:alert', {
                        icon: 'ok',
                        text: 'One of the image ' + files[temp].name + ' is not a valid image extensions. Please check the image and import again.',
                        type: 'danger',
                        timeout: 4000
                    });
                }
            });
        });
    }

    function downloadAllAnnotations(event) {
        mainFolder = '';
        var zip = new JSZip();
        jszip = zip;
        this.breadcrumbs.forEach(element => {
            if (element.attributes["login"] != undefined) {
                mainFolder = mainFolder + element.attributes["login"] + '_';
            } else if (element.attributes["name"] != undefined) {
                mainFolder = mainFolder + element.attributes["name"] + '_';
            }
        });

        mainFolder = mainFolder + `${formatDate(new Date()).replace('.','_')}`;
        var mainzip = zip.folder(mainFolder);
        if (this.itemCount > 0 && this.folderCount > 0) {
            getsubFolders(this.parentModel.attributes, mainzip, "items");
            this.folderListView.collection.models.forEach(folderItem => {
                getsubFolders(folderItem.attributes, mainzip);
            });
        } else if (this.folderCount > 0) {
            this.folderListView.collection.models.forEach(folderItem => {
                getsubFolders(folderItem.attributes, mainzip);
            });
        } else if (this.itemCount > 0) {
            getsubFolders(this.parentModel.attributes, mainzip);
        }
    }

    function getsubFolders(folderInfo, parentFolder, type) {
        counter++;
        restRequest({
            type: 'GET',
            url: `folder?parentType=folder&parentId=${folderInfo._id}&limit=1000000000&sort=lowerName&sortdir=1`
        }).done((response) => {
            restRequest({
                type: 'GET',
                url: `item?folderId=${folderInfo._id}&limit=1000000000&sort=lowerName&sortdir=1`
            }).done((items) => {
                counter--;
                if (type != "items") {
                    parentFolder = parentFolder.folder(folderInfo.name);
                    if (response.length != 0) {
                        response.forEach(folder => {
                            getsubFolders(folder, parentFolder);
                        });
                    }
                }
                items.forEach(item => {
                    getAnnotationsInfo(item, parentFolder);
                });
            });

        });
    }

    function getAnnotationsInfo(item, zippedFolder) {
        counter++;
        restRequest({
            type: 'GET',
            url: `annotation/item/${item._id}`
        }).done((annotations) => {
            counter--;
            var fileName = item.name + ' _annotations.json';
            var annotationData = JSON.stringify(annotations);
            if (annotations.length != 0) {
                zippedFolder.file(fileName, annotationData);
            }
            if (counter == 0) {
                jszip.generateAsync({
                        type: "blob"
                    })
                    .then(function (content) {
                        var a = document.createElement('a');
                        a.download = mainFolder;
                        a.href = URL.createObjectURL(content);
                        a.click();
                    });
            }
        });
    }

    function updateCheckAll(event) {
        this.folderListView.checkAll(event.currentTarget.checked);
        this.folderListView.trigger('g:analysesboxesChanged');

        if (this.itemListView) {
            this.itemListView.checkAll(event.currentTarget.checked);
            this.itemListView.trigger('g:analysesboxesChanged');
        }
    }

    function updateAnalyses() {
        var folders = this.folderListView.checked,
        items = [];

        // Only show actions corresponding to the minimum access level over
        // the whole set of checked resources.
        var minFolderLevel = AccessType.ADMIN;
        _.every(folders, function (cid) {
            var folder = this.folderListView.collection.get(cid);
            minFolderLevel = Math.min(minFolderLevel, folder.getAccessLevel());
            return minFolderLevel > AccessType.READ; // acts as 'break'
        }, this);

        var minItemLevel = AccessType.ADMIN;
        if (this.itemListView) {
            items = this.itemListView.checked;
            if (items.length) {
                minItemLevel = Math.min(minItemLevel, this.parentModel.getAccessLevel());
            }
        }

        // Disable folder actions if checkboxes are checked
        let anyChecked = folders.length + items.length > 0;
        this.$('.g-analyses-actions-button').girderEnable(anyChecked);

        if (anyChecked) {
            if (!this.analysesMenuWidget) {
                this.analysesMenuWidget = new AnalysesMenuWidget({
                   parentView: this
                });
            }

            this.analysesMenuWidget.dropdownToggle = this.$('.g-analyses-actions-button');
            this.analysesMenuWidget.setElement(this.$('.g-analyses-actions-menu'));
            this.analysesMenuWidget.update({
                minFolderLevel: minFolderLevel,
                minItemLevel: minItemLevel,
                folderCount: folders.length,
                itemCount: items.length,
                resources: this._getCheckedResourceParam(true),
            });
        }
    }

    this.listenTo(this.itemListView, 'g:analysesboxesChanged', updateAnalyses);
    this.listenTo(this.folderListView, 'g:analysesboxesChanged', updateAnalyses);
});



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/hierarchy.js